var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.629,
    height: 24.275,
    viewBox: "0 0 26.629 24.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ncm",
    transform: "translate(-4 -6.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1527",
    "data-name": "Caminho 1527",
    d: "M29.2,23.968H27.524V12.049A5.581,5.581,0,0,0,21.95,6.475H7.333A3.337,3.337,0,0,0,4,9.807v3.712a1.913,1.913,0,0,0,1.924,1.9l3.79-.045V27.3a3.454,3.454,0,0,0,3.45,3.449H27.238a3.4,3.4,0,0,0,3.391-3.391V25.394A1.428,1.428,0,0,0,29.2,23.968ZM9.714,14.426l-3.8.045a.951.951,0,0,1-.962-.951V9.807a2.382,2.382,0,0,1,4.763,0ZM13.164,29.8a2.5,2.5,0,0,1-2.5-2.5V9.807A3.322,3.322,0,0,0,9.659,7.425H21.95a4.629,4.629,0,0,1,4.623,4.624V23.968H17.089a1.428,1.428,0,0,0-1.427,1.427V27.3a2.5,2.5,0,0,1-2.5,2.5Zm16.514-2.44a2.443,2.443,0,0,1-2.44,2.44H15.54a3.44,3.44,0,0,0,1.073-2.5V25.394a.476.476,0,0,1,.476-.476H29.2a.476.476,0,0,1,.476.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1528",
    "data-name": "Caminho 1528",
    d: "M28.086,30.7a.476.476,0,0,0,.362-.1l5.67-4.543a.475.475,0,0,0-.594-.742l-5.279,4.23-1.783-2.483a.476.476,0,0,0-.773.554l2.075,2.89a.477.477,0,0,0,.322.194Z",
    transform: "translate(-11.329 -9.825)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcm);
export default __webpack_public_path__ + "static/media/ncm.0db1a48dfb734d633e5fd00b8b5bf128.svg";
export { ForwardRef as ReactComponent };